import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'tableName',
      type: 'input',
      label: '表名',
      placeholder: '请输入表名',
      rules: { required: true, message: '表名是必传的', trigger: 'blur' }
    },
    {
      field: 'tableComment',
      type: 'input',
      label: '表中文名',
      placeholder: '请输入表中文名'
    },
    {
      field: 'menuUrl',
      type: 'input',
      label: '菜单路径',
      placeholder: '请输入表中菜单路径'
    },
    {
      field: 'isPublish',
      type: 'select',
      label: '是否发布',
      placeholder: '请选择',
      clearable: true,
      options: [
        { title: '未发布', value: 0 },
        { title: '已发布', value: 1 }
      ]
    },
    {
      field: 'isChild',
      type: 'select',
      label: '是否子表',
      placeholder: '请选择',
      clearable: true,
      options: [
        { title: '否', value: 0 },
        { title: '是', value: 1 }
      ],
      otherOptions: {
        ctlField: 'mainTableId',
        check(value: any) {
          return value != 1
        }
      }
    },
    {
      field: 'mainTableId',
      type: 'select',
      label: '主表',
      placeholder: '请选择',
      clearable: true,
      options: [],
      otherOptions: {
        disabled: true
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
